import React from 'react'
import Header from '../../../components/Dashboard/Header'
import Question from '../../../components/Dashboard/Innovator/Question'

function Help() {
  return (
    <div className=' min-h-screen bg-[#F3F4FF]'>

      <Header/>
      
      <Question/>
    </div>
  )
}

export default Help
